'use client';

import { useEffect, useState } from 'react';
import { getAllStories } from '@/services/storyApiService';
import { Story } from '@/utils/types';
import StoriesGrid from '@/components/StoriesGrid';
import { AUTHORS } from '@/constants/authors';

export default function PurplekookPage() {
  const [stories, setStories] = useState<Story[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStories = async () => {
      try {
        const data = await getAllStories(AUTHORS.PURPLEKOOK.id);
        
        setStories(data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    loadStories();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="w-12 h-12 border-4 border-primary
          border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <StoriesGrid
      stories={stories}
      title={AUTHORS.PURPLEKOOK.title}
      description={AUTHORS.PURPLEKOOK.description}
    />
  );
}
